<div class="renovations">
    <div class="renovations--loading">
        <span *ngIf="!urlLoaded" class="sc-icon icon-loading sc-icon-2x spinner color-brand-01"></span>
    </div> 
    <iframe *ngIf="iframeUrl" title="Iframe all quotations" [ngClass]="{ 'hidden': !urlLoaded, 'showing':urlLoaded }" class="renovations--iframe" [attr.src]="iframeUrl | safe" (load)="onLoaded($event)"></iframe>
</div>